import React from 'react';
import cn from 'classnames';
import dateTimeFormat from 'legacy-src/utility/DateTime';
import Icon from 'chameleon/ui-stack/ui/base/icon';
import {
  CASFields,
  getStudentCASValue,
  useCheckConflictualDates,
} from './utils';

const StartsAt = ({ parentAssignment, customSetting }) => {
  const { value: startsAt, isCustomSetting } = getStudentCASValue({
    field: CASFields.StartsAt,
    parentAssignment,
    customSetting,
  });

  const hasStartDateBefore = useCheckConflictualDates(
    CASFields.StartsAt,
    parentAssignment,
    customSetting,
  );

  return (
    <div
      className={cn({
        'font-bold': isCustomSetting,
        'text-red-600': hasStartDateBefore,
      })}
    >
      {startsAt
        ? dateTimeFormat(startsAt, 'dateAndTime', parentAssignment.timezone)
        : '-'}
      {isCustomSetting && (
        <span className="mx-1">
          * <span className="sr-only">has exception </span>
        </span>
      )}
      {hasStartDateBefore && (
        <span className="inline-block align-middle">
          <Icon
            accessibility={{
              title: 'Warning - Start Date is ahead of the Due Date',
            }}
            name="warning_triangle"
            className="fill-red-500"
          />
        </span>
      )}
    </div>
  );
};

export default StartsAt;
